/** API route map: URLS.Controller.BenefitLifeEvent */
export const BenefitLifeEvent = {
      Name: 'BenefitLifeEvent/',
      GetBenefitLifeEvents: 'get-benefit-life-event-dropdown',
};
